<div class="group">
  <div class="title" *ngIf="titleVisible">{{ group.name || 'Групповой этап' }}</div>
  <div class="loading" *ngIf="loading">
    <mtg-spinner></mtg-spinner>
  </div>
  <ng-container *ngIf="!loading">
    <mtg-hockey-standings
      *ngIf="tournament.sport.isHockey()"
      [tournament]="tournament"
      [teams]="teams"
    ></mtg-hockey-standings>
    <mtg-volleyball-standings
      *ngIf="tournament.sport.isVolleyball()"
      [tournament]="tournament"
      [teams]="teams"
    ></mtg-volleyball-standings>
    <mtg-basketball-standings
      *ngIf="tournament.sport.isBasketball()"
      [tournament]="tournament"
      [teams]="teams"
    ></mtg-basketball-standings>
    <mtg-football-standings
      *ngIf="tournament.sport.isFootball()"
      [tournament]="tournament"
      [teams]="teams"
    ></mtg-football-standings>
    <mtg-handball-standings
      *ngIf="tournament.sport.isHandball()"
      [tournament]="tournament"
      [teams]="teams"
    ></mtg-handball-standings>
    <mtg-rugby-standings
      *ngIf="tournament.sport.isRugby()"
      [tournament]="tournament"
      [teams]="teams"
      [gameResultsVisible]="isChess"
    ></mtg-rugby-standings>
  </ng-container>
</div>
